<div class="page">
  <div class="header">
    <button mat-icon-button class="header-button" (click)="cerrar()">
      <mat-icon>arrow_back</mat-icon>
    </button>

    <div>
      <h1>{{ esEdicion ? 'Editar médico o enfermero' : 'Agregar médico o enfermero' }}</h1>
    </div>
  </div>

  <mat-dialog-content class="dialog-content">
    <form [formGroup]="form" class="dialog-form">
      <mat-form-field appearance="outline">
        <mat-label>Nombre(s)</mat-label>
        <input matInput placeholder="Nombre(s)" formControlName="nombre" />
        <mat-error>
          @if (form.get('nombre')?.hasError('required')) {
            El nombre es obligatorio.
          }
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Apellido paterno</mat-label>
        <input matInput placeholder="Apellido paterno" formControlName="apellidoPaterno" />
        <mat-error>
          @if (form.get('apellidoPaterno')?.hasError('required')) {
            El apellido paterno es obligatorio.
          }
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Apellido materno</mat-label>
        <input matInput placeholder="Apellido materno" formControlName="apellidoMaterno" />
        <mat-error>
          @if (form.get('apellidoMaterno')?.hasError('required')) {
            El apellido materno es obligatorio.
          }
        </mat-error>
      </mat-form-field>

      @if (!esEdicion) {
        <mat-form-field appearance="outline">
          <mat-label>Email</mat-label>
          <input matInput type="email" placeholder="correo@ejemplo.com" formControlName="email" />
          @if (form.get('email')?.hasError('required')) {
            <mat-error>El correo es obligatorio.</mat-error>
          }
          @if (form.get('email')?.hasError('email')) {
            <mat-error>Ingresa un correo electrónico válido.</mat-error>
          }
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Contraseña</mat-label>

          <input
            matInput
            [type]="mostrarPassword ? 'text' : 'password'"
            placeholder="********"
            formControlName="password"
          />

          <button
            mat-icon-button
            matSuffix
            type="button"
            (click)="mostrarPassword = !mostrarPassword"
            [attr.aria-label]="mostrarPassword ? 'Ocultar contraseña' : 'Mostrar contraseña'"
          >
            <mat-icon>
              {{ mostrarPassword ? 'visibility_off' : 'visibility' }}
            </mat-icon>
          </button>

          @if (form.get('password')?.hasError('required')) {
            <mat-error>La contraseña es obligatoria.</mat-error>
          }

          @if (form.get('password')?.hasError('minlength')) {
            <mat-error>Debe tener al menos 8 caracteres.</mat-error>
          }
        </mat-form-field>
      }

      <mat-form-field appearance="outline">
        <mat-label>Profesión</mat-label>
        <mat-select formControlName="rolId">
          @for (rol of roles; track rol.id) {
            <mat-option [value]="rol.id">{{ rol.nombre }}</mat-option>
          }
        </mat-select>
        <mat-error>
          @if (form.get('rolId')?.hasError('required')) {
            La profesión es obligatoria.
          }
        </mat-error>
      </mat-form-field>

      <div formArrayName="cedulas" class="cedulas-container">
        @for (grupo of cedulas.controls; track grupo; let i = $index) {
          <div [formGroupName]="i" class="cedula-item">
            <h3>Cédula profesional {{ i + 1 }}</h3>

            <mat-form-field appearance="outline">
              <mat-label>Tipo de cédula</mat-label>

              <mat-select formControlName="tipoCedula">
                @for (tipo of tiposCedula; track tipo.valor) {
                  <mat-option [value]="tipo.valor">
                    {{ tipo.nombre }}
                  </mat-option>
                }
              </mat-select>

              @if (grupo.get('tipoCedula')?.hasError('required')) {
                <mat-error>Selecciona el tipo de cédula.</mat-error>
              }
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Número de cédula</mat-label>

              <input
                matInput
                type="text"
                inputmode="numeric"
                autocomplete="off"
                maxlength="8"
                placeholder="12345678"
                formControlName="cedula"
              />

              @if (grupo.get('cedula')?.hasError('pattern')) {
                <mat-error>La cédula debe tener entre 7 y 8 dígitos numéricos.</mat-error>
              }

              @if (grupo.get('cedula')?.hasError('pattern')) {
                <mat-error>Introduce solo números.</mat-error>
              }
            </mat-form-field>

            @if (cedulas.length > 1) {
              <button mat-button type="button" color="warn" (click)="eliminarCedula(i)">
                <mat-icon>delete</mat-icon>
                Quitar cédula
              </button>
            }
          </div>
        }
      </div>

      @if (!esEdicion) {
        <button mat-stroked-button type="button" (click)="agregarCedula()">
          <mat-icon>add</mat-icon>
          Agregar otra cédula
        </button>
      }

      @if (esEdicion) {
        <p class="nota-edicion">El correo y la contraseña no se pueden modificar desde aquí.</p>
      }

      <button
        mat-flat-button
        type="button"
        class="add-boton add-boton--fin-grid add-boton--flexible"
        (click)="guardar()"
      >
        <mat-icon class="material-symbols-outlined">person_check</mat-icon>
        {{ esEdicion ? 'Guardar cambios' : 'Dar de alta' }}
      </button>
    </form>
  </mat-dialog-content>
</div>
